if (!customElements.get('variant-selection-properties')) {
  class VariantSelectionProperties extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');

      if (!this.form) return;

      this.update();

      this.unsubscribeVariantChange = subscribe(
        PUB_SUB_EVENTS.variantChange,
        () => {
          /*
           * Dawn updates the form's variant ID as part of its variant
           * processing. Waiting one microtask ensures we read the new value.
           */
          queueMicrotask(() => this.update());
        }
      );

      this.form.addEventListener('submit', this.handleSubmit, {
        capture: true,
      });
    }

    disconnectedCallback() {
      this.unsubscribeVariantChange?.();
      this.unsubscribeVariantChange = undefined;

      this.form?.removeEventListener('submit', this.handleSubmit, {
        capture: true,
      });

      this.form = undefined;
    }

    handleSubmit = () => {
      this.update();
    };

    update() {
      if (!this.form) return;

      const variantId = this.form.querySelector('[name="id"]')?.value;

      if (!variantId) {
        this.clearProperty();
        this.renderMessage('');
        return;
      }

      this.updateProperty(variantId);
      this.updateMessage(variantId);
    }

    updateProperty(variantId) {
      const inputs = this.querySelectorAll('[data-variant-property]');

      inputs.forEach((input) => {
        input.removeAttribute('name');

        if (input.dataset.variantId === String(variantId)) {
          const propertyKey = input.dataset.propertyKey?.trim();

          if (propertyKey) {
            input.name = `properties[${propertyKey}]`;
          }
        }
      });
    }

    clearProperty() {
      this.querySelectorAll('[data-variant-property]').forEach((input) => {
        input.removeAttribute('name');
      });
    }

    updateMessage(variantId) {
      const source = Array.from(
        this.querySelectorAll('[data-variant-message-source]')
      ).find(
        (element) =>
          element.dataset.variantId === String(variantId)
      );

      this.renderMessage(source?.textContent?.trim() || '');
    }

    renderMessage(message) {
      const output = this.querySelector('[data-variant-message]');

      if (!output) return;

      output.textContent = message;
      output.hidden = !message;
    }
  }

  customElements.define(
    'variant-selection-properties',
    VariantSelectionProperties
  );
}